import { injectReducer } from "store/reducers";
import Levels from "MultiLevelNodeEditor/routes/Levels";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "pyp-atl",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "SubjectsSetup/modules/SubjectsModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const subjectSetupReducer = importedModule2.default;
        injectReducer(store, {
          key: "subjectsSetup",
          reducer: subjectSetupReducer,
        });
        injectReducer(store, {
          key: "multiLevelNodeEditor",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Levels(store)],
});
